import * as React from 'react';
import { Component } from 'react';

export interface IHowItWorksContentUIProps {
    cardHeading: string;
    secondaryText: string;
    iconType: string;
    isFinal?: boolean;
}

export interface IHowItWorksContentUIState {
}

class HowItWorksContentUI extends Component<IHowItWorksContentUIProps, IHowItWorksContentUIState> {

    constructor(props: IHowItWorksContentUIProps) {
        super(props);
    }

    render() {
        const { isFinal, cardHeading, secondaryText, iconType } = this.props;
        const className = isFinal ? 'enjoy-your-ride' : 'header';
        const containerClass = isFinal ? 'how-it-works-component enjoy-ride' : 'how-it-works-component';
        return (
            <div className={containerClass}>
                <div className="icon-container">
                    <div className={`how-it-works-icon ${iconType}`} />
                </div>
                <div className="card-text">
                    <div className={className}>{cardHeading}</div>
                    <div className="secondary">{secondaryText}</div>
                </div>
            </div>
        );
    }
}

export default HowItWorksContentUI;
